import { SlideCarousel } from 'ui-kit'
import Quote from '../Products/Quote'
import type { TestimonialsAttributes } from '../../types/cms'

/** Renders a Strapi `products.testimonials` block as a quote carousel. */
const ProductTestimonials = ({
  title,
  backgroundColour,
  testimonialItems,
}: TestimonialsAttributes) => {
  const items = testimonialItems ?? []

  if (items.length === 0) return null

  return (
    <SlideCarousel
      showIndicators={items.length > 1}
      indicatorSx={{
        position: 'absolute',
        bottom: { xs: '1.5rem', md: '2rem' },
      }}
    >
      {items.map(item => (
        <Quote
          key={item.author}
          title={title}
          author={item.author}
          text={item.testimonial}
          backgroundColour={backgroundColour}
        />
      ))}
    </SlideCarousel>
  )
}

export default ProductTestimonials
